import React, { useState, useEffect } from 'react';

import Icon from '@mui/material/Icon';
import DeviceHubRoundedIcon from '@mui/icons-material/DeviceHubRounded';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';


// material
import { alpha, styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
  Card, Box, Grid, Typography, Accordion,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  TextField,
  InputAdornment,
  FormHelperText
} from '@mui/material';
import { LoadingButton } from '@mui/lab';


import SvgIcon from '@mui/material/SvgIcon';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';

import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import axios from 'axios';

import { APP_CONSTANTS } from '../../../URLConstants';
import { fdatetimeWithDash } from '../../../utils/formatTime'
import {parseValidationErrorMessage} from '../../../utils/Utilities'
import { useAuth } from '../../customContextProviders/AuthContext';
import {CreateUserInOrganization, UpdateUserInOrganization} from '../../../network/Organization'
import AlertDialog from '../../AlertDialog'







// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: "#FFFFFF"
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));


const useStyles = makeStyles({
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "190px"
  },
});


const style = {
  width: '100%',
  maxWidth: { sm: '90%', xs: '90%', md: 600 },
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '30%',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};


const UserSchema = Yup.object().shape({
  userName: Yup.string()
    .required('Required'),
  userPassword: Yup.string()
  .when('userData', {
    is: (value) => !value, // Condition: Password required if userData is not provided
    then: Yup.string().required('Password is required'),
    otherwise: Yup.string() // Password not required if userData is provided
  }),
  userPhone: Yup.string()
    .required('Required'),
  userEmail: Yup.string()
    .required('Required'),
  userRole: Yup.string()
    .required('Required'),
  // userZone: Yup.object()
  //   .required('Required'),


});






export default function AddUserToOrganizationModal({ opneAssignedModal, handleClose, organizationData,userData }) {



  const { sessionUserData,organizationAudioCubeTerritories,getAudioCubeOrganizationTerritories } = useAuth()

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  useEffect(() => {
        if(sessionUserData?.user?.role===APP_CONSTANTS.USER_ROLE_SUPER_ADMIN && organizationData?.id!==undefined && organizationData?.id!==null  )
        getAudioCubeOrganizationTerritories(organizationData?.id)
  }, [opneAssignedModal,userData]);



  
  const addUserFormik = useFormik({
    initialValues: {
      "userName": userData?.name || '',
      "userEmail": userData?.email || '',
      "userPassword": '',
      "userPhone": userData?.phone || '',
      "userRole": userData?.role || '',
      "userZone": {},
      "userRegion":'',
      "userData": userData 
    },
    enableReinitialize: true,
    validationSchema: UserSchema,
    onSubmit: () => {

        let  zonePath='';
        zonePath=organizationData!==undefined && organizationData!==null ?
        organizationData?.name : sessionUserData?.user?.organization?.name

        if(addUserFormik.values.userRole==='maker'){
            zonePath= `${zonePath}.${addUserFormik?.values?.userZone?.name}`
        }else if(addUserFormik?.values.userRole==='checker'){
          zonePath= `${zonePath}.${addUserFormik?.values?.userZone?.name}.${addUserFormik?.values?.userRegion}`
        }
        
        if(zonePath!=null && zonePath!==undefined && zonePath!=='')
          zonePath = zonePath.replace(/\s+/g, '').toLowerCase()
       

      if(userData!=null && userData!==undefined){

        const payload={
          "role":  addUserFormik?.values?.userRole,
          "zonePath":zonePath
        }

        UpdateUserInOrganization(userData?.id,payload).then((res) => {
            
            addUserFormik.setSubmitting(false)
            handleClose()
            setAlertDialogMetas({ ...alertDialogMetas, message: `${addUserFormik?.values?.userName} details updated successfully !`, title: "User Updated.", btnLabel: "OK" });
            setOpenAlertDialog(true)
  
          }).catch((error) => {
            addUserFormik.setSubmitting(false)
            setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error) , title: "Error", btnLabel: "OK" });
            setOpenAlertDialog(true)
  
          })

      }else{
        CreateUserInOrganization(organizationData?.id, addUserFormik?.values?.userName, addUserFormik?.values?.userEmail,
          addUserFormik?.values?.userPassword, addUserFormik?.values?.userPhone,
          addUserFormik?.values?.userRole, zonePath, "https://www.proxgy.com/assets/logo.png").then((res) => {
            
            addUserFormik.setSubmitting(false)
            handleClose()
            setAlertDialogMetas({ ...alertDialogMetas, message: `${addUserFormik?.values?.userName} successfully created !`, title: "User Created.", btnLabel: "OK" });
            setOpenAlertDialog(true)
  
          }).catch((error) => {
            addUserFormik.setSubmitting(false)
            setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error) , title: "Error", btnLabel: "OK" });
            setOpenAlertDialog(true)
  
          })

      }
      
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = addUserFormik;


  return (
    <Box>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid='create-user'
      >

        <FormikProvider  enableReinitialize="true" value={addUserFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={style}>
              <Typography sx={{ fontSize: 18, fontWeight: 800 }}>Create User </Typography>

              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      label="Name"
                      id="userName"
                      name="userName"
                      autoComplete='off'
                      variant="outlined"
                      {...getFieldProps('userName')}
                      error={Boolean(touched.userName && errors.userName)}
                      helperText={touched.userName && errors.userName}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth >
                    <TextField
                      label="Mobile No"
                      id="userPhone"
                      name="userPhone"
                      variant="outlined"
                      {...getFieldProps('userPhone')}
                      error={Boolean(touched.userPhone && errors.userPhone)}
                      helperText={touched.userPhone && errors.userPhone} />

                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth >
                    <TextField
                      label="Email"
                      id="userEmail"
                      name="userEmail"
                      type="email"
                      variant="outlined"
                      {...getFieldProps('userEmail')}
                      error={Boolean(touched.userEmail && errors.userEmail)}
                      helperText={touched.userEmail && errors.userEmail}
                    />
                  </FormControl>
                </Grid>

                {
                  userData===null || userData===undefined ?
                  <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth >
                    <TextField
                      label="Password"
                      id="userPassword"
                      disabled={userData!==undefined && userData!==null}
                      name="userPassword"
                      type="password"
                      variant="outlined"
                      {...getFieldProps('userPassword')}
                      error={Boolean(touched.userPassword && errors.userPassword)}
                      helperText={touched.userPassword && errors.userPassword}
                    />
                  </FormControl>
                </Grid>
                :
                null
                }

               



                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth >
                    <InputLabel id="user-role-select-label">Role </InputLabel>
                    <Select
                      labelId="user-role-select-label"
                      id="user-role-select"
                      value={addUserFormik?.values.userRole}
                      label="Select Role"
                      data-testid='role'
                      onChange={addUserFormik.handleChange}
                      {...getFieldProps('userRole')}
                      error={Boolean(touched.userRole && errors.userRole)}
                      helperText={touched.userRole && errors.userRole}
                    >
                      <MenuItem value="admin" sx={{ p: 1.5 }}>  Admin</MenuItem>
                      <MenuItem value="maker" sx={{ p: 1.5 }}> Maker</MenuItem>
                      <MenuItem value="checker" sx={{ p: 1.5 }}> Checker</MenuItem>

                    </Select>
                  </FormControl>
                </Grid>

               {  addUserFormik?.values?.userRole==='maker' ||
                  addUserFormik?.values?.userRole==='checker' ?

                      <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth >
                          <InputLabel id="user-zone-select-label">Zone </InputLabel>
                          <Select
                            labelId="user-zone-select-label"
                            id="user-zone-select"
                            value={addUserFormik?.values?.userZone}
                            label="Zone"
                            onChange={addUserFormik?.handleChange}
                            {...getFieldProps('userZone')}
                            error={Boolean(touched.userZone && errors.userZone)}
                            helperText={touched.userZone && errors.userZone}
                          >
                              {organizationAudioCubeTerritories?.filter(obj=>obj?.parent_id==="0")?.map((terr)=>(
                                  <MenuItem key={terr?.id} value={terr} sx={{ p: 1.5 }}>  {terr?.name}</MenuItem>
                              ))}
                                
                          </Select>
                        </FormControl>
                      </Grid>
                :
                null
            }


                { addUserFormik?.values?.userRole==='checker' ?

                    <Grid item xs={12} sm={12} md={12}>
                    <FormControl fullWidth >
                        <InputLabel id="user-region-select-label">Region </InputLabel>
                        <Select
                          labelId="user-region-select-label"
                          id="user-region-select"
                          value={addUserFormik?.values?.userRegion}
                          label="Region "
                          onChange={addUserFormik?.handleChange}
                          {...getFieldProps('userRegion')}
                          error={Boolean(touched.userRegion && errors.userRegion)}
                          helperText={touched.userRegion && errors.userRegion}
                        >
                            {organizationAudioCubeTerritories?.filter(obj=>obj?.parent_id===addUserFormik?.values?.userZone?.id)?.map((terr)=>(
                                <MenuItem key={terr?.id} value={terr?.name} sx={{ p: 1.5 }}>  {terr?.name}</MenuItem>
                            ))}
                              
                        </Select>
                      </FormControl>
                    </Grid>
                    :
                    null
                }

                

              </Grid>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <LoadingButton data-testid='create-button' loading={addUserFormik.isSubmitting} sx={{ mt: 3, borderRadius:'10px', height: '40px' }} variant="contained" type='submit' size="large" >Create</LoadingButton>

              </Box>


            </Box>
          </Form>
        </FormikProvider>

      </Modal>

      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />
    </Box>
  );
}

